<template>
  <main class="invitation-login">
    <LoadingIndicator message="Opening bid invitation…" />
  </main>
</template>

<script setup lang="ts">
import {onBeforeMount} from 'vue';

import LoadingIndicator from '@/components/LoadingIndicator.vue';
import clientSubdomain from '@/use/clientSubdomain';

onBeforeMount(() => {
  const apiUrl = new URL(import.meta.env.VITE_APP_API_URL);
  const invitationUrl = new URL(`${window.location.pathname}${window.location.search}`, apiUrl);
  const subdomain = clientSubdomain();

  if (subdomain) {
    invitationUrl.searchParams.set('subdomain', subdomain);
  }

  window.location.replace(invitationUrl.toString());
});
</script>

<style scoped lang="scss">
.invitation-login {
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
}
</style>
